import React from "react";

const About = () => {
  return (
    <div
      name="about"
      id="about"
      className="w-full h-screen bg-[#0a192f]"
    >
      <div className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center h-full w-full text-white">
        <div>
          <p className="text-4xl font-bold inline border-b-4 border-pink-600">
            About
          </p>
        </div>
        <p className="text-xl mt-8">
          With hands-on experience in full-stack web development and backend programming, I’ve built modern, responsive applications 
          at <span className="text-pink-600">100Devs</span> and developed robust backend systems 
          at <span className="text-pink-600">Remodel Health</span>. I focus on creating efficient and scalable solutions, whether it’s optimizing database performance, 
          refining code quality, or building intuitive user interfaces.
          <br/>
          <br/>
          I believe collaboration with cross-functional teams is key to ensuring that every project meets its business objectives and provides seamless user experiences. 
          My goal is always to drive business success through high-quality, user-centered solutions.
        </p>
      </div>
    </div>
  );
};

export default About;